import { loadable } from '@Components/Utilities/SandhillsLoadable';
const Autocomplete = loadable(() => import('@Components/MuiWrappers/Autocomplete'));

export const KeywordSearch = (props) => {
    const getAutocompleteAdditionalData = () => {
        let additionalData = {};

        additionalData.ListingType = encodeURIComponent('For Charter');

        return additionalData;
    };

    return (
        <div className='drill-content'>
            <div className='drill-search'>
                <Autocomplete
                    label={'Keywords'}
                    ajaxOptions={{ additionalData: getAutocompleteAdditionalData() }}
                    searchOptions={{ additionalData: getAutocompleteAdditionalData() }}
                    styles={{ bgVariant: 'white' }}
                />
            </div>
        </div>
    );
}

export default KeywordSearch;